<template>
  <div class="loading">
    <div class="logo">
      <div class="blue"></div>
      <div class="gray"></div>
    </div>
  </div>
</template>

<script>
export default {
  name:'loading',
  data(){
    return{

    }
  },
  mounted() {

  }
};
</script>

<style scoped>
.loading{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: #fff;
  opacity: 1;
  animation: show 1s forwards;
}
@keyframes show {
  from{
    opacity: 1;
  }
  to{
    opacity: 0;
  }
}
.loading .logo{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 210px;
  height: 68px;
}
.loading .blue{
  position: absolute;
  top: 0;
  left: 0;
  width: 187px;
  height: 53px;
  background: url('../assets/home/b.png')no-repeat left;
  z-index: 3;
  animation: logo 2s infinite linear;
}
.loading .gray{
  position: absolute;
  top: 0;
  left: 0;
  width: 187px;
  height: 53px;
  background: url('../assets/gray.png')no-repeat left;
  z-index: 2;
}
.loading.loaded{
  transition: 2s;
  transform: translateX(-120%);
  opacity: 0;
}
@keyframes logo {
  0% {
    width: 0;
  }
  100% {
    width: 210px;
  }
}
</style>


